import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Actions from './actions';
import PublicFiles from '../../Components/PublicFiles/PublicFiles.tsx';
import {
  loadingSelector,
  errorSelector,
  publicFilesUrlsSelector,
} from './selectors';
import { currentUserSelector } from '../App/selectors';

const { getFiles, uploadFile } = Actions;

const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  publicFilesUrls: publicFilesUrlsSelector(state),
  currentUser: currentUserSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  getFiles: (getType) => dispatch(getFiles(getType)),
  uploadFile: (formData) => dispatch(uploadFile(formData)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PublicFiles),
);
